import {
  VantifyProxyResponse,
  vantifyRequest,
} from 'integrations-vantify-api-client';
import { VantifyAuth, VantifyQuery } from '../common';
import { Site, SiteListResponse, SiteAssociateListResponse } from './types';

/**
 * Get all sites by automatically handling pagination
 * Fetches all sites data by making multiple API calls if needed
 */
export async function getAllSites(
  auth: VantifyAuth,
  query?: VantifyQuery
): Promise<VantifyProxyResponse<SiteListResponse>> {
  const DEFAULT_LIMIT = 500;
  const allSites: Site[] = [];
  let currentPage = 1;
  let totalPages;
  let totalCount = 0;

  do {
    const response = await vantifyRequest<SiteListResponse>({
      method: 'GET',
      pathname: 'sites',
      query: {
        ...query,
        page: currentPage,
        limit: DEFAULT_LIMIT,
      },
      auth,
    });

    if (response.status !== 200) {
      return response;
    }

    const data = response.data;

    allSites.push(...data.sites);
    totalPages = data.pages;
    totalCount = data.count;

    currentPage++;
  } while (currentPage <= totalPages);

  return {
    status: 200,
    statusText: 'OK',
    data: {
      sites: allSites,
      count: totalCount,
      pages: totalPages,
      limit: DEFAULT_LIMIT,
    },
  };
}

/**
 * Get site details by site ID
 */
export async function getSiteDetails(
  auth: VantifyAuth,
  siteId: number
): Promise<VantifyProxyResponse<Site>> {
  return await vantifyRequest<Site>({
    method: 'GET',
    pathname: `sites/${siteId}`,
    auth,
  });
}

/**
 * Get site associates for a specific site
 */
export async function getSiteAssociates(
  auth: VantifyAuth,
  siteId: number,
  query?: VantifyQuery
): Promise<VantifyProxyResponse<SiteAssociateListResponse>> {
  return await vantifyRequest<SiteAssociateListResponse>({
    method: 'GET',
    pathname: `sites/${siteId}/associates`,
    query: query || {},
    auth,
  });
}
